import React, { useContext, useEffect } from "react";
import ArtistSeries from "../../layouts/ArtistSeries/ArtistSeries";
import CountdownSection from "../../layouts/CountdownSection/CountdownSection";
import Explanatory from "../../layouts/Explanatory/Explanatory";
import FAQSection from "../../layouts/FAQSection/FAQSection";
import Footer from "../../layouts/Footer/Footer";
import Hero from "../../layouts/Hero/Hero";
import LaunchDay from "../../layouts/LaunchDay/LaunchDay";
import Partners from "../../layouts/Partners/Partners";
import ShareModal from "../../layouts/ShareModal/ShareModal";
import TeamSection from "../../layouts/TeamSection/TeamSection";
import { AppContext } from "../../context/AppContext";
import styles from "./Main.module.scss";
import ReadMoreModal from "../../layouts/ReadMoreModal/ReadMoreModal";
import Hotline from "../../layouts/Hotline/Hotline";

export default function Main() {
  const ctx = useContext(AppContext);
  const { modalType } = ctx;
  useEffect(() => {
    console.log(window.location.hash, "HASH");
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      const element = document.getElementById(hash);
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [window.location.hash]);

  return (
    <div className={styles.wrapper}>
      <Hero />
      <Partners />
      <CountdownSection />
      <ArtistSeries />
      {/* <Explanatory /> */}
      {/* <LaunchDay /> */}
      <TeamSection />
      {/* <FAQSection /> */}
      <Footer />
      <Hotline
        isVisible={
          modalType?.toLowerCase() == "get notified" ||
          modalType?.toLowerCase() == "notify me"
        }
      />
      <ShareModal
        isVisible={
          modalType?.toLowerCase() == "share" ||
          modalType?.toLowerCase() == "tell your frens"
        }
      />
      <ReadMoreModal isVisible={modalType?.toLowerCase() == "read more"} />
    </div>
  );
}
